import { FullBasicPost } from 'model';
import { PostTypeViewProps } from './types.js';
import { PostTitle } from '../PostTitle.js';
import { BigImageContainer } from '../BigImageContainer.js';
import { PostContentsSummary } from '../PostContentsSummary.js';
import { LinkPreviewComponent } from '../LinkPreviewComponent.js';
// eslint-disable-next-line css-modules/no-unused-class
import postStyles from '../../styles/posts.module.css';
import { filterInlineImages } from '../../util/filterInlineImages.js';
import { PostHeader } from '../PostHeader.js';

export function BasicView({ post, detail, preview = false, expanded, testId }: PostTypeViewProps<FullBasicPost>) {
	return (
		<>
			<PostHeader post={post} />
			<PostTitle postId={post._id}>{post.title}</PostTitle>
			{!preview && (
				<div className={postStyles.postBody} data-testid={testId}>
					{detail && post.images.length > 0 && (
						<BigImageContainer post={post} images={filterInlineImages(post.contents, post.images)} />
					)}
					<PostContentsSummary post={post} allowExpand={detail} expanded={expanded} />
					<LinkPreviewComponent linkPreview={post.linkPreview} />
					{!detail && post.images.length > 0 && (
						<BigImageContainer post={post} images={filterInlineImages(post.contents, post.images)} />
					)}
				</div>
			)}
			{preview && !post.title && (
				<PostTitle postId={post._id}>{post.contents.substring(0, 80) + '...'}</PostTitle>
			)}
		</>
	);
}
